import React from 'react';
import styled from 'styled-components';
import { FlexCenterVertical } from 'styles/flexbox';

const Component = styled(FlexCenterVertical)`
  &:not(:last-of-type) {
    margin-bottom: 1em;
  }
`;

const Description = styled.p`
  margin-left: 1em;
`;

const IconStatiItem = ({ icon, description }) => (
  <Component>
    {icon}
    <Description>{description}</Description>
  </Component>
);

export default IconStatiItem;
